import { put, call, all, takeLatest, select } from "redux-saga/effects";
import * as TYPES from "./prescribeTypes";
import * as prescribeApi from "./prescribeAPIs";
import { getBaseUrl } from "~/utils/getBaseUrl";

function* getAllPrescribeWorker({ data }) {
  try {
    yield put({ type: TYPES.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(prescribeApi.getAllPrescribe, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    if (response.data.error_message)
      throw new Error(response.data.error_message);
    yield put({
      type: TYPES.GET_ALL_PRESCRIBE_SUCCESS,
      data: response.data.data
    });
    yield put({ type: TYPES.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: TYPES.GET_ALL_PRESCRIBE_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: TYPES.HIDE_LOADING });
  }
}

function* getPrescribeDetailByDateWorker({ data }) {
  try {
    yield put({ type: TYPES.SHOW_LOADING });
    yield put({ type: TYPES.SELECT_PRESCRIBE, date: data.date });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(
      prescribeApi.getDetailByDatePrescribe,
      baseUrl,
      data
    );
    if (response.status !== 200) throw new Error("Server error");
    if (response.data.error_message)
      throw new Error(response.data.error_message);
    yield put({
      type: TYPES.GET_DETAIL_PRESCRIBE_BY_DATE_SUCCESS,
      data: response.data.data
    });
    yield put({ type: TYPES.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: TYPES.GET_DETAIL_PRESCRIBE_BY_DATE_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: TYPES.HIDE_LOADING });
  }
}

export default function* watcher() {
  yield all([
    takeLatest(TYPES.GET_ALL_PRESCRIBE_REQUEST, getAllPrescribeWorker),
    takeLatest(
      TYPES.GET_DETAIL_PRESCRIBE_BY_DATE_REQUEST,
      getPrescribeDetailByDateWorker
    )
  ]);
}
